import React, { Suspense, useEffect, useState } from "react";
import { Route, Routes as Switch, useNavigate } from "react-router-dom";
import {
  ADD_CONSERVATION,
  LIST_CONSERVATION,
  ADD_CATEGORY,
  ADD_GROUP,
  ADD_MATERIAL,
  ADD_MUSEUM,
  ADD_OBJECT,
  ADD_ROLES,
  ADD_STORAGE,
  ADD_UNIT,
  ADD_USER,
  EDIT_CATEGORY,
  EDIT_GROUP,
  EDIT_MATERIAL,
  EDIT_MUSEUM,
  EDIT_OBJECT,
  EDIT_PHOTOGRAPHY,
  EDIT_PROFILE,
  EDIT_ROLES,
  EDIT_STORAGE,
  EDIT_UNIT,
  EDIT_USER,
  KANBAN_BOARD,
  LIST_CATEGORY,
  LIST_GROUP,
  LIST_LOCATION,
  LIST_MATERIAL,
  LIST_MUSEUM,
  LIST_OBJECT,
  LIST_PHOTOGRAPHY,
  LIST_ROLES,
  LIST_STORAGE,
  LIST_UNIT,
  LIST_USER,
  VIEW_PROFILE,
  lIST_NOTIFICATION,
  PREFERENCE,
  CONSERVATION_KANBAN,
  GLOBAL_SEARCH,
  QR_LOCATION_MANAGMENT,
  ACTIVITY_LOG_LIST,
  HOME_URL,
  ADMIN_DETAIL,
  ADMIN_DETAILS,
  BULK_ACCESSION,
  FILE_URL,
  TRANSIT_FORM_LIST,
  RELEASE_NOTE,
  OBJECT_PIN,
  EXHIBITION_ADD,
  EXHIBITION_LIST,
  EXHIBITION_EDIT,
  TRNSIT_OBJECT_LIST,
  TRANSIT_INNER_LIST,
  TRANSIT_EDIT,
  HELP_CENTER,
} from "./constants/routers";
import Loader from "./components/common/Common/Loader";
import Objectpin from "./pages/object-management/Objectpin";
import TransitObject from "./pages/Transit form/TransitObject";
import Transitforminner from "./pages/Transit form/Transitforminner";

// Lazy load all components
const TransitFormList = React.lazy(() =>
  import("./pages/Transit form/TransitFormList")
);
const Help = React.lazy(() => import("./pages/Help/help"));
const Layout = React.lazy(() => import("./components/common/layout/layout"));
const Home = React.lazy(() => import("./pages/home/home"));
const CategoryList = React.lazy(() => import("./pages/category/listCategory"));
const AddCategory = React.lazy(() => import("./pages/category/createCategory"));
const MaterialList = React.lazy(() => import("./pages/material/listMaterial"));
const AddMaterial = React.lazy(() => import("./pages/material/createMaterial"));
const MuseumList = React.lazy(() => import("./pages/museum/listMuseum"));
const AddMuseum = React.lazy(() => import("./pages/museum/createMuseum"));
const RolesList = React.lazy(() => import("./pages/roles/listRoles"));
const AddRoles = React.lazy(() => import("./pages/roles/createRoles"));
const GroupList = React.lazy(() => import("./pages/groups/listGroup"));
const AddGroup = React.lazy(() => import("./pages/groups/createGroup"));
const UserList = React.lazy(() => import("./pages/users/listUser"));
const AddUser = React.lazy(() => import("./pages/users/createUser"));
const EditProfile = React.lazy(() => import("./pages/auth/viewProfile"));
const StorageTypeList = React.lazy(() =>
  import("./pages/storage-type/storageTypeList")
);
const CreateStorageType = React.lazy(() =>
  import("./pages/storage-type/createStorageType")
);
const UnittypeList = React.lazy(() => import("./pages/unit-type/unittypeList"));
const UnitTypecreate = React.lazy(() =>
  import("./pages/unit-type/unitTypecreate")
);
const ObjectAdd = React.lazy(() =>
  import("./pages/object-management/objectAdd")
);
const ObjectList = React.lazy(() =>
  import("./pages/object-management/objectList")
);
const EditProfileDetail = React.lazy(() =>
  import("./pages/auth/editProfileDetail")
);
const ErrorPage = React.lazy(() =>
  import("./components/common/Common/404 page/ErrorPage")
);
const Notification = React.lazy(() =>
  import("./pages/Notification/Notification")
);
const Objectphotographydetails = React.lazy(() =>
  import("./pages/objectPhotography/Objectphotographydetails")
);
const Objectphotographylist = React.lazy(() =>
  import("./pages/objectPhotography/Objectphotographylist")
);
const Kanbanboard = React.lazy(() =>
  import("./pages/objectPhotography/Kanbanboard")
);
const Preference = React.lazy(() => import("./pages/auth/preference"));
const Objectconsadd = React.lazy(() =>
  import("./pages/ObjectConservation/objectconsadd")
);
const Conservationkanban = React.lazy(() =>
  import("./pages/ObjectConservation/conservationkanban")
);
const GlobalSearch = React.lazy(() =>
  import("./components/common/Common/globalSearch")
);
const Qrlocationmanagment = React.lazy(() =>
  import("./pages/Qr_location_managment/Qrlocationmanagment")
);
const Activityloglist = React.lazy(() =>
  import("./pages/Activity log/Activityloglist")
);
const Objectadmindetails = React.lazy(() =>
  import("./pages/object-management/Objectadmindetails")
);
const LocationAccord = React.lazy(() =>
  import("./pages/location-management/locationaccordian")
);
const Objectaccession = React.lazy(() =>
  import("./pages/object-management/objectaccession")
);
const Objectconslist = React.lazy(() =>
  import("./pages/ObjectConservation/objectconslist")
);

const Fileurl = React.lazy(() => import("./pages/objectPhotography/Fileurl"));
const Support = React.lazy(() => import("./pages/support/support"));
const PrivateRoutes = () => {
  const [log, setLog] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    const logged = localStorage.getItem("is_logged");
    setLog(logged);
    if (!logged) {
      navigate("/login");
    }
  }, []);

  return (
    <Suspense
      fallback={
        <div style={{ height: "100vh" }}>
          <Loader />
        </div>
      }
    >
      {log && (
        <>
          <Switch>
            <Route exact path="/" element={<Layout />}>
              <Route exact path={`/`} element={<Home />} />
              <Route exact path={`/:museum/${HOME_URL}`} element={<Home />} />
              <Route
                exact
                path={`/:museum/${VIEW_PROFILE}`}
                element={<EditProfile />}
              />
              <Route
                exact
                path={`/:museum/${EDIT_PROFILE}/:profile`}
                element={<EditProfileDetail />}
              />
              <Route
                exact
                path={`/:museum/${PREFERENCE}`}
                element={<Preference />}
              />

              {/* //////////////////category start /////////////////////////*/}
              <Route
                exact
                path={`/:museum/${LIST_CATEGORY}`}
                element={<CategoryList />}
              />
              <Route
                exact
                path={`/:museum/${ADD_CATEGORY}`}
                element={<AddCategory />}
              />
              <Route
                exact
                path={`/:museum/${EDIT_CATEGORY}/:id`}
                element={<AddCategory />}
              />
              {/* //////////////////category end ///////////////////////////*/}

              {/* //////////////////material start /////////////////////////*/}
              <Route
                exact
                path={`/:museum/${LIST_MATERIAL}`}
                element={<MaterialList />}
              />
              <Route
                exact
                path={`/:museum/${ADD_MATERIAL}`}
                element={<AddMaterial />}
              />
              <Route
                exact
                path={`/:museum/${EDIT_MATERIAL}/:id`}
                element={<AddMaterial />}
              />
              {/* //////////////////material end ///////////////////////////*/}

              {/* //////////////////museum start /////////////////////////*/}
              <Route
                exact
                path={`/:museum/${LIST_MUSEUM}`}
                element={<MuseumList />}
              />
              <Route
                exact
                path={`/:museum/${ADD_MUSEUM}`}
                element={<AddMuseum />}
              />
              <Route
                exact
                path={`/:museum/${EDIT_MUSEUM}/:id`}
                element={<AddMuseum />}
              />
              {/* //////////////////museum end ///////////////////////////*/}

              {/* //////////////////roles start /////////////////////////*/}
              <Route
                exact
                path={`/:museum/${LIST_ROLES}`}
                element={<RolesList />}
              />
              <Route
                exact
                path={`/:museum/${ADD_ROLES}`}
                element={<AddRoles />}
              />
              <Route
                exact
                path={`/:museum/${EDIT_ROLES}/:id`}
                element={<AddRoles />}
              />
              {/* //////////////////roles end ///////////////////////////*/}

              {/* //////////////////group start /////////////////////////*/}
              <Route
                exact
                path={`/:museum/${LIST_GROUP}`}
                element={<GroupList />}
              />
              <Route
                exact
                path={`/:museum/${ADD_GROUP}`}
                element={<AddGroup />}
              />
              <Route
                exact
                path={`/:museum/${EDIT_GROUP}/:id`}
                element={<AddGroup />}
              />
              {/* //////////////////group end ///////////////////////////*/}

              {/* //////////////////USER start /////////////////////////*/}
              <Route
                exact
                path={`/:museum/${LIST_USER}`}
                element={<UserList />}
              />
              <Route
                exact
                path={`/:museum/${ADD_USER}`}
                element={<AddUser />}
              />
              <Route
                exact
                path={`/:museum/${EDIT_USER}/:id`}
                element={<AddUser />}
              />
              {/* //////////////////USER end ///////////////////////////*/}

              {/* //////////////////Object start /////////////////////////*/}
              <Route
                exact
                path={`/:museum/${LIST_OBJECT}`}
                element={<ObjectList />}
              />
              <Route
                exact
                path={`/:museum/${ADD_OBJECT}`}
                element={<ObjectAdd />}
              />
              <Route
                exact
                path={`/:museum/${BULK_ACCESSION}`}
                element={<Objectaccession />}
              />
              <Route
                exact
                path={`/:museum/${EDIT_OBJECT}/:id`}
                element={<ObjectAdd />}
              />
              <Route
                exact
                path={`/:museum/${ADMIN_DETAIL}/:id`}
                element={<Objectadmindetails />}
              />
              <Route
                exact
                path={`/:museum/${FILE_URL}`}
                element={<Fileurl />}
              />
              <Route
                exact
                path={`/:museum/${OBJECT_PIN}`}
                element={<Objectpin />}
              />
              {/* //////////////////Object end ///////////////////////////*/}

              {/* //////////////////storage-type start /////////////////////////*/}
              <Route
                exact
                path={`/:museum/${LIST_STORAGE}`}
                element={<StorageTypeList />}
              />
              <Route
                exact
                path={`/:museum/${ADD_STORAGE}`}
                element={<CreateStorageType />}
              />
              <Route
                exact
                path={`/:museum/${EDIT_STORAGE}/:id`}
                element={<CreateStorageType />}
              />
              {/* //////////////////storage-type end ///////////////////////////*/}

              {/* //////////////////unit-type start /////////////////////////*/}
              <Route
                exact
                path={`/:museum/${LIST_UNIT}`}
                element={<UnittypeList />}
              />
              <Route
                exact
                path={`/:museum/${ADD_UNIT}`}
                element={<UnitTypecreate />}
              />
              <Route
                exact
                path={`/:museum/${EDIT_UNIT}/:id`}
                element={<UnitTypecreate />}
              />
              {/* //////////////////unit-type end ///////////////////////////*/}

              {/* //////////////////location start /////////////////////////*/}
              <Route
                exact
                path={`/:museum/${LIST_LOCATION}`}
                element={<LocationAccord />}
              />
              {/* //////////////////location end ///////////////////////////*/}

              {/* /////////////Notification///////////// */}
              <Route
                exact
                path={`/:museum/${lIST_NOTIFICATION}`}
                element={<Notification />}
              />

              {/*///////////////photography list///////////////////*/}
              <Route
                exact
                path={`/:museum/${LIST_PHOTOGRAPHY}`}
                element={<Objectphotographylist />}
              />
              <Route
                exact
                path={`/:museum/${EDIT_PHOTOGRAPHY}/:id`}
                element={<Objectphotographydetails />}
              />
              <Route
                exact
                path={`/:museum/${KANBAN_BOARD}`}
                element={<Kanbanboard />}
              />
              {/*///////////////photography list///////////////////*/}

              {/*///////////////conservation start///////////////////*/}
              <Route
                exact
                path={`/:museum/${LIST_CONSERVATION}`}
                element={<Objectconslist />}
              />
              <Route
                exact
                path={`/:museum/${ADD_CONSERVATION}/:id`}
                element={<Objectconsadd />}
              />
              <Route
                exact
                path={`/:museum/${CONSERVATION_KANBAN}`}
                element={<Conservationkanban />}
              />
              {/*///////////////conservation end///////////////////*/}

              {/* /////////////Global Search///////////// */}
              <Route
                exact
                path={`/:museum/${GLOBAL_SEARCH}`}
                element={<GlobalSearch />}
              />

              {/*////////////////////////////////Qr-code location managment/////////////////////////////*/}
              <Route
                exact
                path={`/:museum/${QR_LOCATION_MANAGMENT}/:id`}
                element={<Qrlocationmanagment />}
              />
              {/*////////////////////////////////Qr-code location managment/////////////////////////////*/}

              {/*////////////////////////////////Object Admin details/////////////////////////////*/}
              <Route
                exact
                path={`/:museum/${ADMIN_DETAILS}/:id`}
                element={<Objectadmindetails />}
              />
              {/*////////////////////////////////Object Admin details/////////////////////////////*/}

              {/* ///////////////////////////////support start//////////////////////////// */}
              <Route
                exact
                path={`/:museum/${RELEASE_NOTE}`}
                element={<Support />}
              />
              {/* ///////////////////////////////support end//////////////////////////// */}

              {/* ///////////////////////////////activity log start//////////////////////////// */}
              <Route
                exact
                path={`/:museum/${ACTIVITY_LOG_LIST}`}
                element={<Activityloglist />}
              />
              {/* ///////////////////////////////activity log end//////////////////////////// */}
              {/* ///////////////////////////////support start//////////////////////////// */}
              <Route
                exact
                path={`/:museum/${RELEASE_NOTE}`}
                element={<Support />}
              />
              {/* ///////////////////////////////support end//////////////////////////// */}

              {/* ///////////////////////////////transit start//////////////////////////// */}
              <Route
                exact
                path={`/:museum/${TRANSIT_FORM_LIST}`}
                element={<TransitFormList />}
              />
              <Route
                exact
                path={`/:museum/${TRNSIT_OBJECT_LIST}`}
                element={<TransitObject />}
              />
              <Route
                exact
                path={`/:museum/${TRANSIT_INNER_LIST}`}
                element={<Transitforminner />}
              />
              <Route
                exact
                path={`/:museum/${TRANSIT_EDIT}/:id`}
                element={<Transitforminner />}
              />
              {/* ///////////////////////////////transit end//////////////////////////// */}
              <Route
                exact
                path={`/:museum/${HELP_CENTER}`}
                element={<Help />}
              />
            </Route>
            <Route exact path={"/*"} element={<ErrorPage />} />
          </Switch>
        </>
      )}
    </Suspense>
  );
};

export default PrivateRoutes;
